import {create} from "zustand";

export const useUserStore = create((set, get) => ({
    user:{},
    initialize: (user) => set( () => ({user: user}))
}))
